<template>
    <div class="slider-item slider-item--top-activities">
        <h2 ref="title" class="slider-item__title">{{ title }}</h2>
        <h3 ref="month" class="slider-item__month">{{ month }}</h3>
        <ul ref="activityList" class="slider-item__list">
            <li v-for="item in activities" :key="item.label" class="slider-item__activity">
                <img
                    :src="`/ressources/logged/img/illustrations/recap2024/slsy-${item.icon}.svg`"
                    alt="icon"
                    width="48"
                />
                <p class="slider-item__activity-value">{{ item.number }}</p>
                <p class="slider-item__activity-label">{{ item.label }}</p>
            </li>
        </ul>
    </div>
</template>
<script>
import anime from 'animejs';

export default {
    name: 'TopMonthActivitiesSlide',
    props: {
        title: {
            type: String,
            required: true,
        },
        month: {
            type: String,
            required: true,
        },
        activities: {
            type: Array,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        isActive(value) {
            if (value) {
                const animatedTimeline = anime.timeline({
                    delay: 300,
                });

                animatedTimeline
                    .add({
                        targets: this.$refs.title,
                        opacity: [0, 1],
                    })
                    .add(
                        {
                            targets: this.$refs.month,
                            translateY: [-40, 0],
                            opacity: [0, 1],
                        },
                        '-=300',
                    )
                    .add(
                        {
                            targets:
                                this.$refs.activityList.querySelectorAll('.slider-item__activity'),
                            scale: [0, 1],
                            opacity: [0, 1],
                            delay: anime.stagger(1000),
                        },
                        '-=200',
                    );
            } else {
                this.$refs.title.removeAttribute('style');
                this.$refs.month.removeAttribute('style');
                const items = this.$refs.activityList.querySelectorAll('.slider-item__activity');

                for (const item of items) {
                    item.removeAttribute('style');
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.slider-item {
    &.slider-item--top-activities {
        align-items: flex-start;
        justify-content: flex-start;
        gap: 40px;
    }

    &__title {
        color: var(--colors-sellsy-brand-primary-50-alpha100);
        font-family: var(--font-families-stack-sans-text), sans-serif;
        font-size: 24px;
        font-weight: 700;
        line-height: 26px;
        margin: 0;
    }

    &__month {
        color: var(--colors-sellsy-brand-primary-10);
        font-family: var(--font-families-stack-sans-text), sans-serif;
        font-size: 56px;
        font-weight: 400;
        line-height: 60px;
        margin: 0;
        opacity: 0;
        text-align: center;
        width: 100%;
    }

    &__list {
        align-items: flex-start;
        display: flex;
        flex-wrap: wrap;
        gap: 32px;
        justify-content: center;
        list-style: none;
        margin: auto 0 0;
        padding: 0;
        row-gap: 32px;
    }

    &__activity {
        align-items: center;
        display: flex;
        flex: 1 1 calc(50% - 20px);
        flex-direction: column;
        opacity: 0;

        &-value {
            color: var(--colors-sellsy-brand-primary-05);
            font-family: var(--font-families-stack-sans-text), sans-serif;
            font-size: 24px;
            font-weight: 500;
            line-height: 26px;
            margin: var(--spacing-3) 0 0;
        }

        &-label {
            color: var(--colors-sellsy-brand-primary-10);
            font-family: var(--font-families-stack-sans-text), sans-serif;
            font-size: 17px;
            font-weight: 400;
            line-height: 18px;
            margin: 0;
            text-align: center;
        }
    }
}
</style>
